import { useCallback, useEffect } from 'react'
import { Button, Container } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'

import { useLocalStorage } from '../contexts/LocalStorageContext'
import { useSpeech } from '../contexts/SpeechContext'
import Swal from 'sweetalert2'

const Config = () => {
  const navigate = useNavigate()
  const { config, setParam, initConfig, clearHistory } = useLocalStorage()
  const { speak, stopSpeak } = useSpeech()

  const toggleVoice = () => {
    if (!config.enableVoice) {
      speak('Aide vocale activée')
    }
    setParam('enableVoice', !config.enableVoice)
  }

  const initConfigAction = useCallback(() => {
    if (config.enableVoice) {
      speak('Cette action va effacer toutes les données et la configuration actuelle')
    }
    Swal.fire({
      icon: 'warning',
      title: 'Cette action va effacer toutes les données et la configuration actuelle',
      showCancelButton: true,
    }).then((res) => {
      if (res.isConfirmed) {
        initConfig()
        navigate('/')
      } else {
        stopSpeak()
      }
    })
  }, [config.enableVoice, initConfig, navigate, speak, stopSpeak])

  const clearHistoryAction = useCallback(() => {
    if (config.enableVoice) {
      speak('Cette action va effacer l\'historique de vos documents analysés')
    }
    Swal.fire({
      icon: 'warning',
      title: 'Cette action va effacer l\'historique de vos documents analysés',
      showCancelButton: true,
    }).then((res) => {
      if (res.isConfirmed) {
        clearHistory()
        if (config.enableVoice) {
          speak('Votre historique a bien été effacé')
        }
        Swal.fire({
          icon: 'success',
          title: 'Votre historique a bien été effacé'
        })
      } else {
        stopSpeak()
      }
    })
  }, [clearHistory, config.enableVoice, speak, stopSpeak])

  useEffect(() => {
    if (config.enableVoice) {
      speak('Configuration')
    }
  }, [])

  return (
    <>
      <Container className="h-100">
        <div className="d-flex flex-column h-100 text-center">
          <div style={{ backgroundColor: 'white' }} className="d-flex align-items-center">
            <Button className="btn btn-secondary m-3" onClick={() => navigate('/')}><i className="bi bi-house-fill"> </i></Button>
            <h1>Configuration</h1>
          </div>

          <Button className={config.enableVoice ? 'my-3 btn-success' : 'my-3 btn-danger'} onClick={toggleVoice}>
            <h3>
              <i className="bi bi-volume-up-fill"> </i>
              Aide vocale
            </h3>
            <h4>
              {config.enableVoice ? 'Activé' : 'Désactivé'}
            </h4>
          </Button>

          <Button className="btn-primary my-3" disabled={config.history.length === 0} onClick={() => navigate('/History')}>
            <h3>
              <i class="bi bi-clock-history"> </i>
              Voir l'historique ({config.history.length})
            </h3>
          </Button>

          <Button className="btn-warning my-3" onClick={clearHistoryAction}>
            <h3>
              <i className="bi bi-trash3-fill"> </i>
              Vider l'historique
            </h3>
          </Button>

          <Button className="btn-danger my-3" onClick={initConfigAction}>
            <h3>
              <i className="bi bi-recycle"> </i>
              Réinitialiser
            </h3>
          </Button>
        </div>
      </Container>
    </>
  )
}

export default Config
